import { gql } from '@apollo/client';

export const deleteUser = gql`
  mutation DeleteUser($id: ID!) {
    data: deleteUser(id: $id)
  }
`;
